import React, {Component} from "react";
import Logo from "./Logo";
import LiveChat from 'react-livechat';

class Footer extends Component {
    email(e) {
        e.preventDefault();
        window.open('mailto:support@rigchecksems.com');
    }

    instagram(e) {
        e.preventDefault();
        window.open('https://www.instagram.com/rigchecks/');
    }

    facebook(e) {
        e.preventDefault();
        window.open('https://www.facebook.com/rigchecksems/');
    }

    render() {
        return (
            <footer className="container pt-4 mb-md-2 mt-md-5 pt-md-5 border-top">
                <LiveChat
                    onChatLoaded={ref => this.livechat = ref}
                    license={10046523}/>
                <div className="row">
                    <div className="col-12 col-md">
                        <Logo height={"40px"} width={"40px"}/>
                        <small className="d-block mb-3 text-muted">RigChecks LLC © 2018</small>
                    </div>
                    <div className="col-6 col-md">
                        <h5>Product</h5>
                        <ul className="list-unstyled text-small">
                            <li><a className="text-muted" href="/features">Features</a></li>
                            <li>
                                <a className="text-muted" target="_blank" rel="noopener noreferrer"
                                   href="https://dashboard.rigchecksems.com/login">Login</a>
                            </li>
                            <li>
                                <a className="text-muted" target="_blank" rel="noopener noreferrer"
                                   href="https://dashboard.rigchecksems.com/signup">Signup</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-6 col-md">
                        <h5>Resources</h5>
                        <ul className="list-unstyled text-small">
                            <li><a className="text-muted" href="/pricing">Pricing</a></li>
                            <li><a className="text-muted" href="/terms">Terms & Conditions</a></li>
                        </ul>
                    </div>
                    <div className="col-6 col-md">
                        <h5>Download</h5>
                        <ul className="list-unstyled text-small">
                            <li>
                                <a className="text-muted" target="_blank" rel="noopener noreferrer"
                                   href="https://play.google.com/store/apps/details?id=com.rigchecks.app">
                                    <i className="fa fa-android text-success"/> Android
                                </a>
                            </li>
                            <li>
                                <a className="text-muted disabled">
                                    <i className="fa fa-apple text-muted"/> iOS (Coming soon)
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-6 col-md">
                        <h5>Contact</h5>
                        <ul className="list-unstyled text-small">
                            <li>
                                <button onClick={this.email} type="button"
                                        className="btn btn-sm btn-email m-1 text-white">
                                    <i className="fa fa-envelope mr-2"></i>Email
                                </button>
                            </li>
                            <li>
                                <button onClick={this.instagram} type="button"
                                        className="btn btn-sm btn-instagram m-1 text-white">
                                    <i className="fa fa-instagram mr-2"></i>Instagram
                                </button>
                            </li>
                            <li>
                                <button onClick={this.facebook} type="button"
                                        className="btn btn-sm btn-facebook m-1 text-white">
                                    <i className="fa fa-facebook-square mr-2"></i>Facebook
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>
            </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/component/Footer.js